/* ============================================================
   DUSK & RELIC — PDP interactions v2 (scoped to [data-dnr-product])
   - real variant selection (option radios → hidden id, price,
     installment note, availability)
   - gallery: ‹ › arrows cycle media, thumbnails switch, active state;
     on mobile a tiny thumb strip tracks the snap-scroller both ways
   - add-to-cart via fetch (real cart) + "Added to Bag ✦" flash,
     mobile sticky mirror, dnr:bag event → header badge
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var root = document.querySelector('[data-dnr-product]');
    if (!root) return;

    var form = root.querySelector('form');
    var idInput = root.querySelector('[data-dnr-variant-id]');
    var addBtn = root.querySelector('[data-dnr-add]');
    var mirrorBtn = root.querySelector('[data-dnr-add-mirror]');
    var msg = root.querySelector('[data-dnr-add-msg]');
    // accordions render closed everywhere; desktop opens the first one
    // (open_first) — deterministic on mobile, no attribute race
    if (window.matchMedia && window.matchMedia('(min-width:750px)').matches) {
      var openFirst = document.querySelector('.dnr2-accs > details[data-dnr-openfirst]');
      if (openFirst) openFirst.open = true;
    }

    var priceEls = root.querySelectorAll('[data-dnr-price]');
    var instEl = root.querySelector('[data-dnr-installment]');

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-dnr-variants]').textContent); } catch (e) {}

    /* ---- variant selection ---- */
    function selectedOptions() {
      var groups = {};
      root.querySelectorAll('[data-dnr-option]:checked').forEach(function (r) {
        groups[r.getAttribute('data-dnr-option')] = r.value;
      });
      var positions = Object.keys(groups).map(Number).sort(function (a, b) { return a - b; });
      return positions.map(function (p) { return groups[p]; });
    }

    function arraysEqual(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) { if (String(a[i]) !== String(b[i])) return false; }
      return true;
    }

    function setPrice(txt) { priceEls.forEach(function (el) { el.textContent = txt; }); }

    function setAddState(available) {
      [addBtn, mirrorBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !available;
      });
    }

    function onOptionChange() {
      var match;
      if (!root.querySelector('[data-dnr-option]')) {
        // single default variant (no option selectors rendered)
        match = variants[0];
      } else {
        var sel = selectedOptions();
        match = variants.find(function (v) { return arraysEqual(v.options, sel); });
      }
      root.querySelectorAll('[data-dnr-optlabel]').forEach(function (el) {
        var pos = el.getAttribute('data-dnr-optlabel');
        var r = root.querySelector('[data-dnr-option="' + pos + '"]:checked');
        if (r) el.textContent = r.value;
      });
      if (!match) { setAddState(false); return; }
      if (idInput) idInput.value = match.id;
      if (match.price) setPrice(match.price);
      if (instEl && match.installment) instEl.textContent = match.installment;
      var pairWas = root.querySelector('[data-dnr-pair-was]');
      var pairNow = root.querySelector('[data-dnr-pair-now]');
      if (pairWas && match.price) pairWas.textContent = match.price;
      if (pairNow && match.pairPrice) pairNow.textContent = match.pairPrice;
      setAddState(match.available);
    }

    root.querySelectorAll('[data-dnr-option]').forEach(function (r) {
      r.addEventListener('change', onOptionChange);
    });

    /* ---- gallery ---- */
    var mainImg = root.querySelector('[data-dnr-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dnr-thumb]'));
    var gIdx = 0;

    function showImage(i) {
      if (!thumbs.length || !mainImg) return;
      gIdx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[gIdx];
      var full = t.getAttribute('data-full');
      if (full) { mainImg.src = full; mainImg.removeAttribute('srcset'); }
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { showImage(i); });
    });
    var gPrev = root.querySelector('[data-dnr-gprev]');
    var gNext = root.querySelector('[data-dnr-gnext]');
    if (gPrev) gPrev.addEventListener('click', function () { showImage(gIdx - 1); });
    if (gNext) gNext.addEventListener('click', function () { showImage(gIdx + 1); });

    /* ---- add to cart ---- */
    function flash(text, ok) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = text;
      msg.style.color = ok ? '' : '#e08f8f';
    }

    function syncBag() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          window.dispatchEvent(new CustomEvent('dnr:bag', { detail: { count: cart.item_count } }));
        })
        .catch(function () {});
    }

    function addToCart() {
      if (!form) return;
      var data = new FormData(form);
      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      if (addBtn) addBtn.disabled = true;
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (addBtn) addBtn.disabled = false;
          if (!res.ok) { flash(res.body.description || res.body.message || 'Could not add to bag.', false); return; }
          if (addBtn && addBtn.dataset.addedLabel) {
            addBtn.textContent = addBtn.dataset.addedLabel;
            setTimeout(function () { restoreAddLabel(); }, 2200);
          }
          flash('Added to bag ✦', true);
          syncBag();
          // slide in the cart drawer (dnr-v2.js listens for this)
          window.dispatchEvent(new CustomEvent('dnr:cart:open'));
        })
        .catch(function () { flash('Could not add to bag.', false); if (addBtn) addBtn.disabled = false; });
    }

    function restoreAddLabel() {
      if (!addBtn || !addBtn.dataset.addLabel) return;
      var priceEl = root.querySelector('.dnr2-buy__price');
      var priceTxt = priceEl ? priceEl.textContent.trim() : '';
      addBtn.innerHTML = '';
      addBtn.appendChild(document.createTextNode(addBtn.dataset.addLabel + (priceTxt ? ' — ' : '')));
      if (priceTxt) {
        var span = document.createElement('span');
        span.setAttribute('data-dnr-price', '');
        span.textContent = priceTxt;
        addBtn.appendChild(span);
        priceEls = root.querySelectorAll('[data-dnr-price]');
      }
    }

    if (form) { form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); }); }
    if (mirrorBtn) { mirrorBtn.addEventListener('click', function () { addToCart(); }); }

    /* ---- Size guide slide-in (One-Size products) ---- */
    var sizeDw = document.querySelector('[data-dnr-sizedw]');
    if (sizeDw && sizeDw.parentElement !== document.body) document.body.appendChild(sizeDw);
    function sizeDwSet(open) {
      if (!sizeDw) return;
      sizeDw.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-dnr-sizedw-open]')) { e.preventDefault(); sizeDwSet(true); return; }
      if (e.target.closest('[data-dnr-sizedw-close]')) { sizeDwSet(false); return; }
      if (sizeDw && !sizeDw.hidden && e.target.closest('[data-dnr-sizedw]') && !e.target.closest('.dnr2-sizedw__panel')) { sizeDwSet(false); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sizeDwSet(false); });

    /* ---- "About the Design" panel (description read-more) ---- */
    var aboutDw = document.querySelector('[data-dnr-aboutdw]');
    // escape sticky/filtered ancestors so the fixed panel spans the viewport
    if (aboutDw && aboutDw.parentElement !== document.body) document.body.appendChild(aboutDw);
    function aboutSet(open) {
      if (!aboutDw) return;
      aboutDw.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-dnr-aboutdw-open]')) { e.preventDefault(); aboutSet(true); return; }
      if (e.target.closest('[data-dnr-aboutdw-close]')) { aboutSet(false); return; }
    });
    if (aboutDw) {
      aboutDw.addEventListener('click', function (e) {
        if (!(e.target.closest && e.target.closest('.dnr2-aboutdw__panel'))) aboutSet(false);
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') aboutSet(false); });
    // show "Read more" only when the clamped description actually overflows
    var descEl = root.querySelector('[data-dnr-desc]');
    var moreBtn = root.querySelector('[data-dnr-aboutdw-open]');
    if (descEl && moreBtn && descEl.scrollHeight <= descEl.clientHeight + 2) {
      moreBtn.parentElement.style.display = 'none';
    }

    /* ---- mobile gallery: thumb strip <-> snap scroller ---- */
    var gstack = root.querySelector('.dnr2-gstack');
    var gthumbs = root.querySelector('[data-dnr-gthumbs]');
    if (gstack && gthumbs) {
      var gimgs = gstack.querySelectorAll('img');
      var gbtns = gthumbs.querySelectorAll('[data-dnr-gthumb]');
      var gbars = root.querySelectorAll('[data-dnr-gbar]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // offsetParent is .dnr2-gallery for both, so this is the offset inside the scroller
      function slideLeft(i) { return gimgs[i].offsetLeft - gstack.offsetLeft; }

      function keepThumbVisible(btn) {
        var l = btn.offsetLeft - gthumbs.offsetLeft;
        var r = l + btn.offsetWidth;
        if (l < gthumbs.scrollLeft) { gthumbs.scrollLeft = l - 6; }
        else if (r > gthumbs.scrollLeft + gthumbs.clientWidth) { gthumbs.scrollLeft = r - gthumbs.clientWidth + 6; }
      }

      function paint(i) {
        gbtns.forEach(function (b, n) { b.classList.toggle('is-on', n === i); });
        gbars.forEach(function (b, n) { b.classList.toggle('is-on', n === i); });
        if (gbtns[i]) keepThumbVisible(gbtns[i]);
      }

      // nearest slide by real offset — gaps make scrollLeft/width drift over 8 images
      function nearest() {
        var best = 0, bestDist = Infinity;
        for (var i = 0; i < gimgs.length; i++) {
          var d = Math.abs(slideLeft(i) - gstack.scrollLeft);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        return best;
      }

      var ticking = 0;
      gstack.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = requestAnimationFrame(function () { ticking = 0; paint(nearest()); });
      }, { passive: true });

      function jumpTo(n) {
        if (!gimgs[n]) return;
        gstack.scrollTo({ left: slideLeft(n), behavior: reduce ? 'auto' : 'smooth' });
        paint(n);
      }
      gbtns.forEach(function (btn, n) { btn.addEventListener('click', function () { jumpTo(n); }); });
      gbars.forEach(function (btn, n) { btn.addEventListener('click', function () { jumpTo(n); }); });
    }

    // initial sync
    onOptionChange();
  });
})();
